import React from "react";
import { useTheme } from "styled-components";
import { Box } from "../../Box";
const EmptyRow = ({ children }) => {
    const { colors: { tableColors }, } = useTheme();
    return (React.createElement(Box, { as: "tr", "data-testid": "emptyRow", sx: {
            borderBottom: `1px solid ${tableColors.tableBorder}`,
            fontWeight: "600",
            textAlign: "center",
        } }, children));
};
/**
 * A row which can be included in a table, and will render only if there are no data rows in the table
 */
export const EmptyTableRow = ({ table, children }) => {
    if (table.getRowCount() === 0) {
        return (React.createElement(EmptyRow, null,
            React.createElement("td", { colSpan: table.getVisibleLeafColumns().length, style: {
                    padding: "75px 0",
                }, "data-testid": "emptyTableRow" }, children)));
    }
    return null;
};
